import { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

class NotFound extends Component {

  componentDidMount() {
    this.props.history.replace('/')
  }

  render() {
    return null
  }

}

NotFound.propTypes = {
  history: PropTypes.object.isRequired
}

export default withRouter(NotFound)
